import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { COMPANY, COUNTRIES, LOGO_URL } from "@/lib/constants";
import { useI18n } from "@/lib/i18n";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-white/10 bg-[#0A0A0A] relative z-10" data-testid="site-footer">
      <div className="dsvm-container py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO_URL} alt="DSVM Group" className="h-12 w-auto" />
          </div>
          <p className="text-white/60 max-w-md leading-relaxed">
            {t("footer.tagline")}
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {COUNTRIES.slice(0, 6).map((c) => (
              <span
                key={c}
                className="text-[11px] uppercase tracking-widest text-white/50 border border-white/10 px-2 py-1"
              >
                {c}
              </span>
            ))}
          </div>
        </div>

        <div>
          <div className="dsvm-label mb-4">{t("footer.navigation")}</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/usluge" className="text-white/70 hover:text-[#C5A059]">{t("nav.services")}</Link></li>
            <li><Link to="/reference" className="text-white/70 hover:text-[#C5A059]">{t("nav.references")}</Link></li>
            <li><Link to="/o-nama" className="text-white/70 hover:text-[#C5A059]">{t("nav.about")}</Link></li>
            <li><Link to="/kontakt" className="text-white/70 hover:text-[#C5A059]">{t("nav.contact")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="dsvm-label mb-4">{t("footer.contact")}</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2 text-white/70">
              <Phone className="w-4 h-4 text-[#C5A059] mt-0.5" /> {COMPANY.phone}
            </li>
            <li className="flex items-start gap-2 text-white/70">
              <Mail className="w-4 h-4 text-[#C5A059] mt-0.5" /> {COMPANY.email}
            </li>
            <li className="flex items-start gap-2 text-white/70">
              <MapPin className="w-4 h-4 text-[#C5A059] mt-0.5" /> {COMPANY.address}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="dsvm-container py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <div className="flex items-center gap-4">
            <span>© {new Date().getFullYear()} DSVM Group. {t("footer.rights")}</span>
            <Link to="/privacy" className="text-white/50 hover:text-[#C5A059] transition-colors" data-testid="footer-privacy-link">
              {t("footer.privacy")}
            </Link>
          </div>
          <div className="font-mono">{t("footer.iso")}</div>
        </div>
      </div>
    </footer>
  );
}
